import React, { useEffect, useState } from 'react';
import CustomTooltip from './customTooltip';
import { getParts } from '../../services/tactonService';

function PartNumberComponent(props) {
  const [parts, setParts] = useState([]);
  const { startData } = props;
  useEffect(() => {
    let partNum = [];
    let partData = getParts(startData);
    if (partData && partData.length > 0) {
      let exsistingParts = parts;
      let commited = false;
      partData.map((part, index) => {
        if (exsistingParts.length > 0) {
          commited =
            exsistingParts.filter(x => x.description == part.description)[0]
              ?.value != part.value
              ? true
              : false;
        }
        partNum.push({
          description: part.description,
          value: part.value,
          commited: commited
        });
      });
      setParts(partNum);
    }
  }, [startData?.infoGroup?.partNumberValues]);
  return (
    <div>
      {parts.map((part, i) => {
        return (
          <CustomTooltip
            title={part.description}
            placement="top"
            key={i + part.value}
          >
            <div
              className={
                part.commited ? 'partNumberBox selectedBox' : 'partNumberBox'
              }
            >
              {part.value}
            </div>
          </CustomTooltip>
        );
      })}
      <hr className="partNumberHR" />
    </div>
  );
}
export default PartNumberComponent;
